// React Imports
import React, { useEffect, useState } from "react";

// Router Imports
import { useNavigate } from "react-router-dom";

// Redux Imports
import { useDispatch, useSelector } from "react-redux";
import { setHideBreadCrumb } from "../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { ReimbursementMultiTxnErrors } from "../../../redux/features/reimbursementTransaction";

// Component Imports
import ICONS from "../../../assets/Icons";
import StatusContainer from "../../_utils/CommonStatus/StatusContainer";
import InfoCard from "../../_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import FormatAmount from "../../_utils/FormatAmount/FormatAmount";

const ReimbursementTxnMultiApprovalError = () => {
  // 1️⃣ useDispatch & useNavigate
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // 2️⃣ useState
  const [ErrorPageData, setErrorPageData] = useState([]);

  // 3️⃣ useSelector
  const {
    ReimbursementMultiTxnWaitingApprovalError,
    ReimbursementMultiTxnDeniedApprovalError,
  } = useSelector((state) => state.reimbursementTransaction);

  // 4️⃣ Constants / Derived values
  const actionType =
    ReimbursementMultiTxnDeniedApprovalError &&
    !ReimbursementMultiTxnWaitingApprovalError
      ? "reject"
      : ReimbursementMultiTxnWaitingApprovalError &&
          !ReimbursementMultiTxnDeniedApprovalError
        ? "approve"
        : "approve";

  const findCommonNames = (arr1, arr2) => {
    const type = arr2.some((item) => typeof item === "string");
    if (type) return arr2;
    const arr2Map = new Map(arr2?.map((item) => [item?.id, item?.errors]));
    return arr1
      .filter((item) => arr2Map?.has(item.txn_id))
      .map((item) => ({
        ...item,
        errors: arr2Map?.get(item.txn_id),
      }));
  };

  const filterErrorTxn = findCommonNames(
    ErrorPageData,
    JSON.parse(sessionStorage.getItem("ReimbursementDataError")) || [],
  );

  // 5️⃣ Callback / Handler functions
  const buttonRows = [
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () => navigate("/reimbursement_transaction_dashboard"),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  const getTitle = () =>
    actionType === "reject"
      ? "Oops! Reimbursement rejection failed"
      : "Oops! Reimbursement approval failed";

  const getSubtitle = () => {
    const action = actionType === "reject" ? "rejection" : "approval";
    return `An error occurred with the following transactions, causing the ${action} of all the transaction to fail.`;
  };

  // 6️⃣ useEffect
  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));
    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
      dispatch(ReimbursementMultiTxnErrors());
    };
  }, [dispatch]);

  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedReimbursementTxnData"),
    );
    if (storedSelectedApproval) {
      setErrorPageData(storedSelectedApproval?.selectedSendTransactions);
    } else {
      setErrorPageData([]);
    }
  }, []);

  return (
    <div>
      <StatusContainer
        status="error"
        buttonRows={buttonRows}
        title={getTitle()}
        subtitle={getSubtitle()}
      >
        <TabsWeapperSection title="Error details">
          <>
            {Array.isArray(filterErrorTxn) &&
              filterErrorTxn.map((val, i) => {
                if (
                  typeof val === "string" &&
                  val.includes("No transactions found for transaction ids")
                ) {
                  return (
                    <InfoCard
                      bgColor="var(--negative-card)"
                      key={i}
                      rows={[
                        {
                          leftTitle: val,
                          leftSubTitle: "Error message",
                        },
                      ]}
                    />
                  );
                }
                return (
                  <React.Fragment key={i}>
                    {val.errors?.map((error, index) => (
                      <InfoCard
                        bgColor="var(--negative-card)"
                        key={index}
                        rows={[
                          {
                            leftTitle: error?.reason || error,
                            leftSubTitle: "Error message",
                          },
                        ]}
                      />
                    ))}
                  </React.Fragment>
                );
              })}
          </>
        </TabsWeapperSection>
        <TabsWeapperSection title="Transaction Details">
          <>
            {Array.isArray(filterErrorTxn) &&
              filterErrorTxn.map((val, i) => {
                if (typeof val === "string") return null;
                return (
                  <InfoCard
                    key={val.txn_id || i}
                    bgColor="var(--negative-card)"
                    onClick={() =>
                      navigate(
                        `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${val?.txn_id}`,
                      )
                    }
                    hoverable="white"
                    rows={[
                      {
                        leftTitle: val.beneficiary_account_name,
                        leftSubTitle: "Account name",
                        hasRight: true,
                        rightText: true,
                        rightTitle: (
                          <>
                            INR <FormatAmount price={val?.amount} />
                          </>
                        ),
                        rightTitleTextColor: "var(--text-primary)",
                        rightTextFontWeight: "semibold",
                        rightSubTitle: "Amount",
                        rightIcon: true,
                      },
                    ]}
                  />
                );
              })}
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </div>
  );
};

export default ReimbursementTxnMultiApprovalError;
